document.addEventListener('DOMContentLoaded', () => {
  const overlaySections = document.querySelectorAll('.aseave-hero-overlay-nav');
  if (!overlaySections.length) return;

  const readCartCount = () => {
    const headerCount = document.querySelector('#cart-icon-bubble .header__cart-count');
    if (headerCount) {
      const match = headerCount.textContent.match(/\d+/);
      if (match) return Number(match[0]);
    }

    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && typeof window.ShopifyAnalytics.meta.cart_count === 'number') {
      return window.ShopifyAnalytics.meta.cart_count;
    }

    return null;
  };

  const updateOverlayCounts = (count) => {
    if (count === null || Number.isNaN(count)) return;
    overlaySections.forEach((section) => {
      section.querySelectorAll('.aseave-hero-overlay-nav__cart-count').forEach((span) => {
        span.textContent = `(${count})`;
      });
    });
  };

  const initialCount = readCartCount();
  if (initialCount !== null) {
    updateOverlayCounts(initialCount);
  }

  document.addEventListener('cart:refresh', (event) => {
    const newCount = event?.detail?.cart?.item_count;
    if (typeof newCount === 'number') {
      updateOverlayCounts(newCount);
      return;
    }

    const fallbackCount = readCartCount();
    if (fallbackCount !== null) {
      updateOverlayCounts(fallbackCount);
    }
  });

  // Hamburger menu functionality
  overlaySections.forEach((section) => {
    const hamburger = section.querySelector('[data-hamburger]');
    const nav = section.querySelector('.aseave-hero-overlay-nav__nav');
    const overlay = section.querySelector('[data-mobile-overlay]');

    if (!hamburger || !nav || !overlay) return;

    const lockScroll = () => {
      if (window.ThemeScrollLock) {
        window.ThemeScrollLock.lock({ classes: ['overlay-nav-open'] });
      } else {
        document.body.style.overflow = 'hidden';
      }
    };

    const unlockScroll = () => {
      if (window.ThemeScrollLock) {
        window.ThemeScrollLock.unlock({ classes: ['overlay-nav-open'] });
      } else {
        document.body.style.overflow = '';
      }
    };

    const closeMenu = () => {
      hamburger.classList.remove('is-active');
      nav.classList.remove('is-active');
      overlay.classList.remove('is-active');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.setAttribute('aria-label', 'メニューを開く');
      unlockScroll();
    };

    const openMenu = () => {
      hamburger.classList.add('is-active');
      nav.classList.add('is-active');
      overlay.classList.add('is-active');
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.setAttribute('aria-label', 'メニューを閉じる');
      lockScroll();
    };

    hamburger.addEventListener('click', () => {
      if (hamburger.classList.contains('is-active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', closeMenu);

    // Close menu on nav link click
    nav.querySelectorAll('.aseave-hero-overlay-nav__link').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    // Close menu on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && hamburger.classList.contains('is-active')) {
        closeMenu();
      }
    });

    // Close menu on window resize to desktop
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 1024 && hamburger.classList.contains('is-active')) {
          closeMenu();
        }
      }, 250);
    });
  });
});
